import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { QRCodeModule } from 'angularx-qrcode';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardCarouselComponent } from './scorecard-carousel/scorecard-carousel.component';
import { ScorecardDescriptionModalComponent } from './scorecard-description-modal/scorecard-description-modal.component';
import { ScorecardListViewComponent } from './scorecard-list-view/scorecard-list-view.component';
import { ScorecardDescriptionModalCarouselComponent } from './scorecard-description-modal-carousel/scorecard-description-modal-carousel.component';
import { ScorecardPrizeSelectionComponent } from './scorecard-prize-selection/scorecard-prize-selection.component';
import { ScorecardSponserViewComponent } from './scorecard-sponser-view/scorecard-sponser-view.component';
import { ScorecardPunchcardViewComponent } from './scorecard-display-types/scorecard-punchcard-view/scorecard-punchcard-view.component';
import { MilestonesProgressViewComponent } from './scorecard-display-types/milestones-progress-view/milestones-progress-view.component';
import { ScorecardNumberViewComponent } from './scorecard-display-types/scorecard-number-view/scorecard-number-view.component';
import { ScorecardLockedComponent } from './scorecard-display-types/scorecard-locked/scorecard-locked.component';
import { ScorecardDescriptionComponent } from './scorecard-description/scorecard-description.component';
import { ScorecardDescriptionHeaderComponent } from './scorecard-description/scorecard-description-header/scorecard-description-header.component';
import { ScorecardDescriptionBodyComponent } from './scorecard-description/scorecard-description-body/scorecard-description-body.component';
import { ScorecardDescriptionActionsComponent } from './scorecard-description/scorecard-description-body/scorecard-description-actions/scorecard-description-actions.component';
import { ScorecardDescriptionLinkedActionComponent } from './scorecard-description/scorecard-description-body/scorecard-description-linked-action/scorecard-description-linked-action.component';
import { SocialShareModalModule } from '@fgb/portal-component-library/src/lib/shared/social-share-modal';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ScorecardStreakComponent } from './scorecard-display-types/scorecard-streak/scorecard-streak.component';

@NgModule({
  declarations: [
    ScorecardCarouselComponent,
    ScorecardDescriptionModalComponent,
    ScorecardDescriptionModalCarouselComponent,
    ScorecardListViewComponent,
    ScorecardPrizeSelectionComponent,
    ScorecardSponserViewComponent,
    ScorecardPunchcardViewComponent,
    MilestonesProgressViewComponent,
    ScorecardNumberViewComponent,
    ScorecardStreakComponent,
    ScorecardLockedComponent,
    ScorecardDescriptionComponent,
    ScorecardDescriptionHeaderComponent,
    ScorecardDescriptionBodyComponent,
    ScorecardDescriptionActionsComponent,
    ScorecardDescriptionLinkedActionComponent,
  ],
  imports: [
    CommonModule,
    PipesModule,
    ShortLongDescriptionModule,
    NgbModule,
    ErrorsModule,
    RouterModule,
    DirectivesModule,
    QRCodeModule,
    CarouselModule,
    FGBSharedModule,
    SocialShareModalModule,
    InlineSVGModule.forRoot(),
  ],
  exports: [
    ScorecardCarouselComponent,
    ScorecardListViewComponent,
    ScorecardDescriptionModalComponent,
    ScorecardDescriptionComponent,
    ScorecardPunchcardViewComponent,
    MilestonesProgressViewComponent,
    ScorecardNumberViewComponent,
    ScorecardLockedComponent,
    ScorecardStreakComponent,
  ],
})
export class ScorecardModule {}
